/* eslint-disable @typescript-eslint/no-unused-vars */
import GenericButton from '@ui-components/Button/GenericButton'
import GenericDropdown from '@ui-components/Dropdown/GenericDropdown'
import { GenericTable } from '@ui-components/Table/GenericTable'
import React, { useState } from 'react'
import { ReactComponent as IconPlus } from "../../../../../shared/assets/Icons/IconPlusV3.svg";

import { getCustomerColumns } from './CustomersTableColumns';
import { Customer } from '../request/request';


export default function CustomerPage() {
        const [customerList, setCustomerList] = useState<Customer[]>([]);

        //Edit Tenant
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editMode, setEditMode] = useState(false);

        // Customers
        const [dataCenterOptions, setDataCenterOptions] = useState<string[]>([]);
        const [selectedCustomerName, setSelectedCustomerName] = useState("");

    // ===== 4) HANDLERS =====
	const handleCustomerSelect = (selected: string) => {
		setSelectedCustomerName(selected);
	};

  //Declare all four handlers:
  const handleViewCustomer = (c: Customer) => {
    // e.g. open a view-only drawer, or console.log
    console.log('viewing', c);
  };

  const handleEditCustomer = (c: Customer) => {
    setEditMode(true);
    setIsModalOpen(true);
  };

  const handleDeleteClick = (c: Customer) => {
    // call your delete API, then refresh list…
    console.log('deleting', c);
  };


  // Safely pass them into getCustomerColumns:
  const columns = getCustomerColumns({
    handleViewCustomer,
    handleEditCustomer,
    handleDeleteClick,
  });


    const handleAddHardware = () => {
		setEditMode(false);
		setIsModalOpen(true);
	};
  return (
    <div className="relative">
			{/* 1) SELECT DATACENTER */}
			<div className="mb-4 p-4 bg-[var(--semantic-bg-primary)] border border-semantic-border-secondary rounded-sm">
				<div className="flex items-end justify-between">
					<div className="flex items-end space-x-4">
						<div className="flex flex-col">
							<label className="mb-1 text-sm font-medium text-semantic-text-secondary">
								Select a Customer
							</label>
							<GenericDropdown
								items={dataCenterOptions}
								defaultLabel="Choose DC..."
								value={selectedCustomerName}
								onSelect={handleCustomerSelect}
								minWidthClass="min-w-[200px]"
								maxWidthClass="max-w-[240px]"
							/>
						</div>
					</div>

					<GenericButton
						label={
							<div className="flex items-center gap-2">
								<IconPlus className="w-4 h-4" />
								<span>Create new customer</span>
							</div>
						}
						variant="brand"
						size="md"
						onClick={handleAddHardware}
					/>
				</div>
			</div>

        {/* 2) TABLA PARTNER */}
        <GenericTable
            columns={columns}
            data={customerList}
            width="100%"
            initialRowsPerPage={5}
            rowsPerPageOptions={[5, 10]}
            tableClassName="bg-semantic-bg-primary"
        />
    </div>
  )
}
